import { _CPSC_20000, _CPSC_24500, _CPSC_24700, _CPSC_36000, _CPSC_44000, _CPSC_44500, _CPSC_49200, _CPSC_61200 } from "./Classes"
import { _CALENDAR_FALL_2026_08_24_16 } from "./Calendars"
import { _INSTRUCTOR_ERIC_POGUE } from "./Instructors"

import { _CPSC_20000_SLIDEDECK_TTR } from "../Slides/SL20000"
import { _CPSC_24500_SLIDEDECK_TTR } from "../Slides/SL24500"
import { _CPSC_44000_SLIDEDECK_TTR } from "../Slides/SL44000"
import { _CPSC_49200_SLIDEDECK_TTR } from '../Slides/SL49200'

// import { students_SP26 } from "./Students"

export const getClassTitleByClassSectionID = (classSectionID) => {
	return getClassSectionByID(classSectionID).course.name
}

export const getClassTitle = () => {
	return getCurrentClassSection().course.name
}

export const getClassNumber = () => {
	return getCurrentClassSection().course.number.toString()
}

export const getClassCalendarByClassSectionID = (classSectionID) => { 
	return getClassSectionByID(classSectionID).calendar.sprintDates
}

export const getClassCalendar = () => { 
	return getCurrentClassSection().calendar.sprintDates
}

export const getClassSectionSchedule = (sprint) => {
	const currentClassSection = getCurrentClassSection()
	if (currentClassSection.meetingDays === _T) {
		return currentClassSection.calendar.sprintDates[sprint-1].scheduleT
	}
	return currentClassSection.calendar.sprintDates[sprint-1].schedule
}

export const getClassSectionScheduleV2 = (sprint) => {
	if (getCurrentClassSection().meetingDays === _T) {
		return getCurrentClassSection().calendar.sprintDates[sprint-1].scheduleT
	}
	return getCurrentClassSection().calendar.sprintDates[sprint-1].schedule
}

export const getFinalExamDateAndTime = () => {
	return getCurrentClassSection().finalExam
}

export const getFinalExamDate = () => {
	return getCurrentClassSection().finalExamDate
}

export const getIsScheduleM = () => {
	return (getCurrentClassSection().meetingDays === _M)
}

export const getIsScheduleT = () => {
	return (getCurrentClassSection().meetingDays === _T)
}

export const getIsScheduleTTr = () => {
	return (getCurrentClassSection().meetingDays === _TTR)
}

export const getIsScheduleOnline = () => {
	return (getCurrentClassSection().meetingDays === _ASYNCHRONOUS)
}

export const getClassSectionID = () => {
	return getCurrentClassSection().id
}

export const getModuleDescriptionByClassSectionID = (classSectionID, moduleIndex) => {
	return getClassSectionByID(classSectionID).course.modules[moduleIndex]
}

export const getModuleDescription = (moduleIndex) => {
	return getCurrentClassSection().course.modules[moduleIndex]
}

export const getModuleDescriptionsByClassSectionID = (classSectionID) => {
	return getClassSectionByID(classSectionID).course.modules
}

export const getModuleDescriptions = () => {
	return getCurrentClassSection().course.modules
}

export const getSlideDecksFromClassSection = () => {
	return getCurrentClassSection().slideDecks
}

// Todo: This should be part of the course or course section data instead of a hardcoded list.
const moduleAssignments = [
	'Discussion, Quiz, Lab, and Reflection',
	'Discussion, Quiz, Lab, and Reflection',
	'Discussion, Quiz, Lab, and Reflection',
	'Discussion, Quiz, Lab, and Reflection',
	'Discussion, Midterm Exam, Lab, and Reflection',
	'Discussion, Quiz, Lab, and Reflection',
	'Discussion, Final Exam, Lab, Reflection, and Lab Demo',
	'Class Project Presentation'
]
export const getModuleAssignment = (module) => {
	return moduleAssignments[module]
}

// To promote encapsulation use 'getAllClassSections()' and 'getClassSectionByID()' sparingly. 
export const getAllClassSections = () => {
	return _CLASS_SECTION_LIST
}

export const getClassSection = () => {
	return getCurrentClassSection().section
}

export const getClassSectionByID = (classSectionID) => {
	for (let i = 0; i < _CLASS_SECTION_LIST.length; i++) {
		if (_CLASS_SECTION_LIST[i].id === classSectionID)
			return _CLASS_SECTION_LIST[i]
	}

	console.log(`Error: Class Section ID “${classSectionID}” not found.`)
	return null
}

const getClassSectionIDfromURL = () => {
	// Depreciated: Use getCurrentClassSectionID() instead.
	return sessionStorage.getItem('classSectionID')
}

// const _MWF = 'MWF'
const _M = 'M'
const _T = 'T'
const _TTR = 'TTh'
const _ASYNCHRONOUS = 'Asynchronous' 

const _DEFAULT_SEMESTER_PREFIX = 'fa26'
const _DEFAULT_CALENDAR = _CALENDAR_FALL_2026_08_24_16

const getCurrentClassSection = () => {
	return getClassSectionByID(getClassSectionIDfromURL())
}

const _FA26_CPSC_24500_001 = {
	'id':'fa26-cpsc-24500-001',
	'section':'001',
	'meetingDays':_TTR,
	'meetingTimes':'12:30-1:45 PM CST',
	'finalExam':'Thursday, December 10 from 10:30 AM to 12:30 PM CT',
	'meetingLocation':'Arts and Sciences AS-106-A',

	'course':_CPSC_24500,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_CALENDAR_FALL_2026_08_24_16,
	'slideDecks':_CPSC_24500_SLIDEDECK_TTR
}

const _FA26_CPSC_44000_001 = {
	'id':'fa26-cpsc-44000-001',
	'section':'001',
	'meetingDays':_TTR,
	'meetingTimes':'9:30-10:45 AM CST',
	'finalExam':'Thursday, December 10 from 8 AM to 10 AM CT',
	'meetingLocation':'Arts and Sciences AS-104-A',

	'course':_CPSC_44000,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_CALENDAR_FALL_2026_08_24_16,
	'slideDecks':_CPSC_44000_SLIDEDECK_TTR
}

const _FA26_CPSC_49200_001 = {
	'id':'fa26-cpsc-49200-001',
	'section':'001',
	'meetingDays':_T,
	'meetingTimes':'2-3:15 PM',
	'finalExam':'Tuesday, December 8 from 1:30 to 3:30 PM CT',
	'meetingLocation':'Arts and Sciences AS-106-A',

	'course':_CPSC_49200,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_CALENDAR_FALL_2026_08_24_16,
	'slideDecks':_CPSC_49200_SLIDEDECK_TTR
}

const _FA26_CPSC_49200_004 = {
	'id':'fa26-cpsc-49200-004',
	'section':'004',
	'meetingDays':_T,
	'meetingTimes':'2-3:15 PM',
	'finalExam':'Tuesday, December 8 from 1:30 to 3:30 PM CT',
	'meetingLocation':'Arts and Sciences AS-106-A',

	'course':_CPSC_49200,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_CALENDAR_FALL_2026_08_24_16,
	'slideDecks':_CPSC_49200_SLIDEDECK_TTR
}

const _XXXX_CPSC_20000_001 = {
	'id':`${_DEFAULT_SEMESTER_PREFIX}-${_CPSC_20000.id}`,
	'section':'001',
	'crn':'11045',
	'meetingDays':_TTR,

	'course':_CPSC_20000,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_DEFAULT_CALENDAR,
	'slideDecks':_CPSC_20000_SLIDEDECK_TTR
}

const _XXXX_CPSC_24700 = {
	'id':`${_DEFAULT_SEMESTER_PREFIX}-${_CPSC_24700.id}`,
	'meetingDays':_TTR,

	'course':_CPSC_24700,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_DEFAULT_CALENDAR
}

const _XXXX_CPSC_36000 = {
	'id':`${_DEFAULT_SEMESTER_PREFIX}-${_CPSC_36000.id}`,
	'meetingDays':_TTR,

	'course':_CPSC_36000,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_DEFAULT_CALENDAR
}

const _XXXX_CPSC_44500 = {
	'id':`${_DEFAULT_SEMESTER_PREFIX}-${_CPSC_44500.id}`,
	'meetingDays':_TTR,

	'course':_CPSC_44500,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_DEFAULT_CALENDAR
}

const _XXXX_CPSC_61200 = {
	'id':`${_DEFAULT_SEMESTER_PREFIX}-${_CPSC_61200.id}`,
	'meetingDays':_T,

	'course':_CPSC_61200,
	'instructor':_INSTRUCTOR_ERIC_POGUE,
	'calendar':_DEFAULT_CALENDAR
}

const _CLASS_SECTION_LIST = [
	_FA26_CPSC_44000_001,
	_FA26_CPSC_24500_001,
	_FA26_CPSC_49200_001,
	_FA26_CPSC_49200_004,
	_XXXX_CPSC_20000_001,
	_XXXX_CPSC_24700,
	_XXXX_CPSC_36000,
	_XXXX_CPSC_44500,
	_XXXX_CPSC_61200,
]
